// Styles
// **************************************
const card = 'rounded bg-surface p-6';
const title = 'text-base font-bold';
const sectionTitle = `${title} px-6 mb-6`;
const readMoreGradient = 'relative -mt-20 h-20 bg-gradient-to-b from-transparent to-surface';
const showMoreButton = 'text-primary hover:text-primary-light';
const grid = 'grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2';

// Export
// **************************************
export const commonStyles = {
  card,
  title,
  sectionTitle,
  readMoreGradient,
  showMoreButton,
  grid,
};
